import { fromJsonArray } from 'src/core/utils';
import { Address } from 'src/entities/basic-types/Address';

export default class CustomerAddresses {
    public allAddresses: Address[];
    public defaultBillingAddress?: Address;
    public defaultDeliveryAddress?: Address;
    public accountAddress?: Address;

    constructor(json: any) {
        this.allAddresses = fromJsonArray(Address, json.allAddresses);
        this.defaultBillingAddress = json.defaultBillingAddress ? new Address(json.defaultBillingAddress) : undefined;
        this.defaultDeliveryAddress = json.defaultDeliveryAddress
            ? new Address(json.defaultDeliveryAddress)
            : undefined;
        this.accountAddress = json.accountAddress ? new Address(json.accountAddress) : undefined;
    }

    public get allConfirmedAddresses(): Address[] {
        return this.allAddresses.filter(address => address.state === 'confirmed');
    }
}
